export default __webpack_public_path__ + "static/media/bg02.ef8d33a7.jpg";